import type { InterestBook } from '@/helpers/billingSourceBook'
import {
  getOnboardingBooks,
  subjectFromBookTags,
  type OnboardingSubject,
} from '@/models/onboarding.personalization'

export interface BookCoverStackSource {
  url_slug: string
  tags: string[]
}

export function getBookCoverUrl(urlSlug: string): string {
  return `//media.shortform.com/covers/png/${urlSlug}-cover.png`
}

export function titleFromBookSlug(urlSlug: string): string {
  return urlSlug
    .split('-')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')
}

export const DEFAULT_INTEREST_BOOK: InterestBook = {
  url_slug: 'atomic-habits',
  title: 'Atomic Habits',
  author: 'James Clear',
  cover_image: getBookCoverUrl('atomic-habits'),
  tags: ['Self-Improvement'],
}

/**
 * Source book first, then peer slugs from the book's category subject.
 * Pass `subject` to override tag-based subject resolution.
 */
export function getBookCoverStackSlugs(
  sourceBook: BookCoverStackSource,
  peerCount = 4,
  subject?: OnboardingSubject,
): string[] {
  const resolvedSubject = subject ?? subjectFromBookTags(sourceBook.tags)
  const peers = getOnboardingBooks(resolvedSubject).filter(
    (slug) => slug !== sourceBook.url_slug,
  )

  return [sourceBook.url_slug, ...peers.slice(0, peerCount)]
}
